import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../../common/components";
import './filter-options-text.scss';

const FirstNameFilter: any = (
  props: any
) => {
  const { firstName, handleFirstNameChange, isFirstNameEnabled, firstNameError } = props
  useEffect(() => {
    if (!isFirstNameEnabled) {
      handleFirstNameChange({ target: { value: "", name: "firstName" } } as any, "firstName");
    }
  }, [isFirstNameEnabled]);
  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          firstName: firstName,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="firstName"
            placeholder="Enter First Name"
            optional={false}
            disabled={false}
            value={firstName}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleFirstNameChange(e, "firstName")
            }
          />
          {firstNameError && <div className="error-text">{firstNameError}</div>}
        </Form>
      </Formik>
    </div>

  );
};
export default FirstNameFilter;